import aboutus from './aboutus/routes';
import contactus from './contactus/routes';
import impressum from './impressum/routes';
import accessibilitystatement from './accessibility/routes';
import aistatement from './ai-statement/routes';

export default [
  aboutus,
  contactus,
  impressum,
  accessibilitystatement,
  aistatement,
];
